import WeatherValidateInterface from '@/utilities/weather/services/interfaces/WeatherValidateInterface'
import WeatherServiceInterface from '@/utilities/weather/services/interfaces/WeatherServiceInterface'

export default class Guard {
  static isValidate(service: WeatherValidateInterface | WeatherServiceInterface): service is WeatherValidateInterface {
    return 'isValid' in service
  }
}
